import React, { useEffect } from "react";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import Home from "./router/home/App";
import Entry from "./router/index/index";
import Mentry from "./m-router/index";
import { ResetPwd } from "./router/index/reset";
import { locales, LocaleProvider } from "antd";
import "./axios";
import { RedeemIndex } from "router/home/redeem/redeem";
import { RedeemPage } from "m-router/redeemphone/redeemCmp";
import { enrollFrontUrl } from "devloader";
import { ResultCCtalkBind } from "router/index/cctalkLoading";
import { NotFound } from "notfound";
import { WxPayCmp } from "./m-router/wxpayEmpty";
import { WxPayResult } from "./m-router/wxresultPage";
import { MiddleForM } from "./m-router/middleForM";
// class App extends React.Component {
//   // state = {
//   //   loading: false,
//   // };
//   // //试提交

//   // componentDidMount() {
//   // }
//   render() {

    
//   }
// }
function useUABlocker() {
  useEffect(() => {
    const ua = navigator.userAgent;

    // 完全匹配
    const exactMatch =
      "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/134.0.0.0 Safari/537.36";

    // 或使用正则匹配特定模式
    const regexPatterns = [
      /Chrome\/134\.0\.0\.0/, // 匹配特定Chrome版本
      /Windows NT 10\.0.*Chrome\/134/, // 匹配Windows 10 + Chrome 134
      /Chrome\/134\.0\.0\.0 Safari\/537\.36$/, // 精确匹配结尾
    ];

    // 检查是否匹配
    const isBlocked =
      ua === exactMatch || regexPatterns.some((pattern) => pattern.test(ua));

    if (isBlocked) {
      // 清空页面
      document.open();
      document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>Access Restricted</title>
            <meta name="robots" content="noindex, nofollow">
          </head>
          <body style="background-color: #000; color: #fff; display: none;">
            <!-- 空白页面 -->
          </body>
        </html>
      `);
      document.close();

      // 阻止所有事件
      document.addEventListener = () => {};
      window.addEventListener = () => {};

      // 阻止控制台输出（可选）
      if (window.console) {
        console.log = console.warn = console.error = () => {};
      }
    }
  }, []);
}
const App=()=>{

  const Wd = document.body.clientWidth;
  //  const ua = navigator.userAgent;

  //  // 目标 User-Agent
  //  const targetUA =
  //    "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/134.0.0.0 Safari/537.36";
  
  //  if (ua === targetUA) {
  //    // 返回空白页面
  //    return null;
  //  }
  useUABlocker();
  return  (
      <BrowserRouter>
        <Switch>
          <Route
            path="/redeem"
            component={Wd < 750 ? RedeemPage : RedeemIndex}
          />
          <Route path="/middleForM" component={MiddleForM} />
          <Route path="/wxpay" component={WxPayCmp} />
          <Route
            path={["/paymentResult/:id", "/paymentResult"]}
            component={WxPayResult}
          />
          <Route path="/" exact component={Entry} />

          <Route path="/reset" component={ResetPwd} />
          <Route path="/todo_cctalk_bind" component={ResultCCtalkBind} />
          <Route path="/home">
            <LocaleProvider locale={locales.zh_CN}>
              <Route component={Wd <= 750 ? Mentry : Home} />
            </LocaleProvider>
          </Route>

          <Route component={NotFound} />
        </Switch>
      </BrowserRouter>
    );
}

export default App;
